import {ModalFormFieldTypes} from 'components/formItems/FormGroup/FormGroup';
import {numberRules} from 'utils/formRules';
import moment from 'moment';

const fields: ModalFormFieldTypes[] = [
	{
		type: 'title',
		label: 'Անձնական տվյալներ'
	},
	{
		name: 'name',
		type: 'text',
		label: 'Անուն',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Անուն'
		}
	},
	{
		name: 'lastname',
		type: 'text',
		label: 'Ազգանուն',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Ազգանուն'
		}
	},
	{
		name: 'middleName',
		type: 'text',
		label: 'Հայրանուն',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Հայրանուն'
		}
	},
	{
		name: 'nameLatin',
		type: 'text',
		label: 'Անուն (լատինատառ)',
		inputProps: {
			placeholder: 'Անուն'
		},
		rules: [{pattern: new RegExp('^[A-Za-z ]{1,100}$'), message: 'Միայն լատինատառ մուտք'}]
	},
	{
		name: 'lastnameLatin',
		type: 'text',
		label: 'Ազգանուն (լատինատառ)',
		inputProps: {
			placeholder: 'Ազգանուն'
		},
		rules: [{pattern: new RegExp('^[A-Za-z ]{1,100}$'), message: 'Միայն լատինատառ մուտք'}]
	},
	{
		name: 'middleNameLatin',
		type: 'text',
		label: 'Հայրանուն (լատինատառ)',
		inputProps: {
			placeholder: 'Հայրանուն'
		},
		rules: [{pattern: new RegExp('^[A-Za-z ]{1,100}$'), message: 'Միայն լատինատառ մուտք'}]
	},
	{
		name: 'dob',
		type: 'date',
		label: 'Ծննդյան թիվ',
		datePickerProps: {
			placeholder: 'Ծննդյան թիվ',
			allowClear: true,
			disabledDate: (current: any) => {
				let customDate = moment().subtract(1, 'days').subtract(14, 'years');
				return current && current > moment(customDate);
			}
		}
	},
	{
		name: 'pob',
		type: 'text',
		label: 'Ծննդավայր (Երկիր / գյուղ / քաղաք)',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Ծննդավայր (Երկիր / գյուղ / քաղաք)'
		}
	},
	{
		name: 'citizenship',
		type: 'text',
		label: 'Քաղաքացիություն',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Քաղաքացիություն'
		}
	},
	{
		name: 'nationality',
		type: 'text',
		label: 'Ազգություն',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Ազգություն'
		}
	},
	{
		name: 'telephone',
		type: 'text',
		label: 'Հեռախոս',
		inputProps: {
			addonBefore: '+',
			placeholder: 'Հեռախոս'
		},
		rules: [numberRules]
	},
	{
		name: 'email',
		type: 'text',
		label: 'Էլ․ փոստ',
		inputProps: {
			placeholder: 'Էլ․ փոստ'
		},
		disabledAt: ['ADD', 'EDIT'],
		rules: [{type: 'email'}]
	},
	{
		name: 'passport',
		type: 'text',
		label: 'Անձնագրի կամ նույնականացման քարտի համար',
		inputProps: {
			placeholder: 'Անձնագրի կամ նույնականացման քարտի համար'
		}
	},
	{
		name: 'genderTypeID',
		type: 'select',
		dictionaryApiPath: 'genderTypes',
		label: 'Սեռ',
		selectProps: {
			placeholder: 'Սեռ'
		}
	},
	{
		name: 'militaryServiceID',
		type: 'select',
		dictionaryApiPath: 'candidateMilitaryService',
		depFieldKey: 'genderTypeID',
		depValue: 1,
		label: 'Ծառայության կարգավիճակ',
		selectProps: {
			placeholder: 'Ծառայության կարգավիճակ'
		}
	},
	{
		name: 'militaryServiceStartDate',
		type: 'date',
		depFieldKey: ['genderTypeID', 'militaryServiceID'],
		depValue: [1, 3],
		label: 'Ծառայության սկիզբ',
		datePickerProps: {
			placeholder: 'Ծառայության սկիզբ',
			format: 'YYYY',
			picker: 'year',
			disabledDate: (current: any) => current.year() > moment().year()
		}
	},
	{
		name: 'militaryServiceEndDate',
		type: 'date',
		depFieldKey: ['genderTypeID', 'militaryServiceID'],
		depValue: [1, 3],
		label: 'Ծառայության ավարտ',
		datePickerProps: {
			placeholder: 'Ծառայության ավարտ',
			format: 'YYYY',
			picker: 'year',
			disabledDate: (current: any) => current.year() > moment().year()
		}
	},
	{
		name: 'militaryServicePlace',
		type: 'text',
		depFieldKey: ['genderTypeID', 'militaryServiceID'],
		depValue: [1, 3],
		label: 'Ծառայության վայր',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Ծառայության վայր'
		}
	},
	{
		name: 'militaryCommissariat',
		type: 'text',
		depFieldKey: ['genderTypeID', 'militaryServiceID'],
		depValue: [(val: any) => val === 1, (val: any) => val !== 2],
		onlyArmenian: true,
		isRequired: false,
		label: 'Զինկոմիսարիատ',
		inputProps: {
			placeholder: 'Զինկոմիսարիատ'
		}
	},
	{
		name: 'militaryCommissariat',
		type: 'text',
		depValue: [(val: any) => val === 1, (val: any) => val === 2],
		depFieldKey: ['genderTypeID', 'militaryServiceID'],
		onlyArmenian: true,
		isRequired: false,
		label: 'Զինկոմիսարիատ',
		inputProps: {
			placeholder: 'Զինկոմիսարիատ'
		}
	},
	{
		type: 'newLine'
	},
	{
		name: 'registrationCountryID',
		type: 'select',
		dictionaryApiPath: 'countries',
		label: 'Երկիր (գրանցում)',
		selectProps: {
			placeholder: 'Երկիր (գրանցում)'
		}
	},
	{
		name: 'registrationCountryOther',
		type: 'text',
		depFieldKey: 'registrationCountryID',
		depValue: 1,
		label: 'Երկիր (գրանցման, այլ)',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Երկիր (գրանցում)'
		}
	},
	{
		name: 'registrationRegionID',
		type: 'select',
		dictionaryApiPath: 'regions',
		label: 'Մարզ (գրանցում)',
		depFieldKey: 'registrationCountryID',
		depValue: 2,
		selectProps: {
			placeholder: 'Մարզ (գրանցում)'
		}
	},
	{
		name: 'registrationRegionOther',
		type: 'text',
		depFieldKey: 'registrationCountryID',
		depValue: (val: number) => val !== 2,
		label: 'Մարզ (գրանցում)',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Մարզ (գրանցում)'
		}
	},
	{
		name: 'registrationCityVillage',
		type: 'text',
		label: 'Քաղաք / գյուղ (գրանցում)',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Քաղաք / գյուղ (գրանցում)'
		}
	},
	{
		name: 'registrationAddress',
		type: 'text',
		label: 'Գրանցման հասցե',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Գրանցման հասցե'
		}
	},
	{
		name: 'residenceIsDifferentFromRegistration',
		type: 'checkbox',
		checkboxProps: {
			children: 'Փաստացի բնակությանս հասցեն տարբերվում է գրանցմանս հասցեից',
			defaultChecked: false
		},
		//@ts-ignore
		formItemProps: {
			//@ts-ignore
			valuePropName: 'checked'
		},
		isRequired: false,
		colProps: {
			xs: 24,
			lg: 24
		}
	},
	{
		name: 'residenceCountryID',
		type: 'select',
		dictionaryApiPath: 'countries',
		depFieldKey: 'residenceIsDifferentFromRegistration',
		depValue: true,
		label: 'Երկիր (բնակություն)',
		selectProps: {
			placeholder: 'Երկիր (բնակություն)'
		}
	},
	{
		name: 'residenceCountryOther',
		type: 'text',
		depFieldKey: ['residenceIsDifferentFromRegistration', 'residenceCountryID'],
		depValue: [true, 1],
		label: 'Երկիր (բնակություն, այլ)',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Երկիր (բնակություն)'
		}
	},
	{
		name: 'residenceRegionID',
		type: 'select',
		depFieldKey: ['residenceIsDifferentFromRegistration', 'residenceCountryID'],
		depValue: [true, 2],
		dictionaryApiPath: 'regions',
		label: 'Մարզ (բնակություն)',
		selectProps: {
			placeholder: 'Մարզ (բնակություն)'
		}
	},
	{
		name: 'residenceRegionOther',
		type: 'text',
		depFieldKey: ['residenceIsDifferentFromRegistration', 'residenceCountryID'],
		depValue: [true, (val: number) => val !== 2],
		label: 'Մարզ (բնակություն)',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Մարզ (բնակություն)'
		}
	},
	{
		name: 'residenceCityVillage',
		type: 'text',
		depFieldKey: 'residenceIsDifferentFromRegistration',
		depValue: true,
		label: 'Քաղաք / գյուղ (բնակություն)',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Քաղաք / գյուղ (բնակություն)'
		}
	},
	{
		name: 'residenceAddress',
		type: 'text',
		depFieldKey: 'residenceIsDifferentFromRegistration',
		depValue: true,
		label: 'Փաստացի բնակության հասցե',
		onlyArmenian: true,
		inputProps: {
			placeholder: 'Փաստացի բնակության հասցե'
		}
	}
];

export default fields;
